module.exports = __webpack_public_path__ + "img/video.1d235d1c.jpeg";